import { reduxConstantFactory } from 'utils/index'

const constantFactory = reduxConstantFactory('routing')

export const RECEIVE_ALL_RULE_DATA = constantFactory('RECEIVE_ALL_RULE_DATA')

export const NEW_RULE = constantFactory('NEW_RULE')
export const UPDATE_RULE = constantFactory('UPDATE_RULE')
export const DELETE_RULE = constantFactory('DELETE_RULE')
export const POINT_RULE_TO_NEW_GROUP = constantFactory(
  'POINT_RULE_TO_NEW_GROUP'
)

export const NEW_RULE_GROUP = constantFactory('NEW_RULE_GROUP')
export const UPDATE_RULE_GROUP = constantFactory('NEW_RULE')
export const UPDATE_DEFAULT_RULE_GROUP_ACTION = constantFactory(
  'UPDATE_DEFAULT_RULE_GROUP_ACTION'
)
export const POINT_DEFAULT_GROUP_ACTION_TO_NEW_GROUP = constantFactory(
  'POINT_DEFAULT_GROUP_ACTION_TO_NEW_GROUP'
)
export const DELETE_RULE_GROUP = constantFactory('DELETE_RULE_GROUP')

export const SAVE_DRAFT = constantFactory('SAVE_DRAFT')
export const DRAFT_SAVED = constantFactory('DRAFT_SAVED')
export const DRAFT_PUBLISHED = constantFactory('DRAFT_PUBLISHED')
export const DRAFT_SAVE_DONE = constantFactory('DRAFT_SAVE_DONE')
export const DRAFT_SAVE_FAILED = constantFactory('DRAFT_SAVE_FAILED')
export const START_DRAFT_SAVE = constantFactory('START_DRAFT_SAVE')
export const REVERT_TO_PUBLISHED_VERSION = constantFactory(
  'REVERT_TO_PUBLISHED_VERSION'
)
export const SET_SHOW_PUBLISHED = constantFactory('SET_SHOW_PUBLISHED')
export const UPDATE_DRAFT_DEFAULT_USER_IDS = constantFactory(
  'UPDATE_DRAFT_DEFAULT_USER_IDS'
)
export const SHOW_SELECT_CONTINUE_TO_GROUP = constantFactory(
  'SHOW_SELECT_CONTINUE_TO_GROUP'
)
export const CHOOSE_SELECT_CONTINUE_TO_GROUP = constantFactory(
  'CHOOSE_SELECT_CONTINUE_TO_GROUP'
)
export const CANCEL_SELECT_CONTINUE_TO_GROUP = constantFactory(
  'CANCEL_SELECT_CONTINUE_TO_GROUP'
)
export const MOVE_RULE = constantFactory('MOVE_RULE')
export const SET_SHOW_ADDING_NEW_RULE = constantFactory(
  'SET_SHOW_ADDING_NEW_RULE'
)
export const SET_SHOW_EDIT_ACTION = constantFactory('SET_SHOW_EDIT_ACTION')
export const SET_HIDE_OPT_IN_FLOW = constantFactory('SET_HIDE_OPT_IN_FLOW')
